document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('[data-recommendations-section]')
  if (!section) return

  const track = section.querySelector('[data-products-track]')
  const bars = track ? Array.from(section.querySelectorAll('[data-indicator-bar]')) : []

  // Mobile carousel
  if (track) {
    const getStep = () => {
      const card = track.querySelector(':scope > [data-recommendations-product]')
      if (!card) return track.clientWidth
      const styles = getComputedStyle(track)
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0
      return card.offsetWidth + gap
    }

    if (bars.length) {
      const updateIndicator = () => {
        const step = getStep()
        const index = step ? Math.round(track.scrollLeft / step) : 0
        bars.forEach((bar, i) => {
          bar.classList.toggle('bg-black-200', i === index)
          bar.classList.toggle('bg-black-12', i !== index)
        })
      }

      let ticking = false
      track.addEventListener('scroll', () => {
        if (ticking) return
        ticking = true
        requestAnimationFrame(() => {
          updateIndicator()
          ticking = false
        })
      })
    }
  }

  // On load animation
  const cards = section.querySelector('[data-recommendations-cards]')
  const headingLines = [...section.querySelectorAll('[data-recommendations-line]')].filter((el) => el.offsetParent)

  const reveal = () => {
    if (!window.gsap) {
      cards?.classList.remove('opacity-0')
      return
    }

    const { gsap } = window
    if (headingLines.length) gsap.to(headingLines, { yPercent: 0, opacity: 1, duration: 0.9, ease: 'power3.out', stagger: 0.12 })
    if (cards) gsap.fromTo(cards, { autoAlpha: 0, y: 40 }, { autoAlpha: 1, y: 0, duration: 1.2, ease: 'power3.out', delay: 0.15 })
  }

  const reset = () => {
    if (!window.gsap) return
    const { gsap } = window
    if (headingLines.length) gsap.set(headingLines, { yPercent: 120, opacity: 0 })
    if (cards) gsap.set(cards, { autoAlpha: 0, y: 40 })
  }

  if (window.gsap && window.ScrollTrigger) {
    const { gsap } = window

    reset()
    window.ScrollTrigger.create({ trigger: section, start: 'top 80%', onEnter: reveal })
    window.ScrollTrigger.create({ trigger: section, start: 'top bottom', onLeaveBack: reset })

    section.querySelectorAll('[data-ritual-card-parallax]').forEach((el) => {
      const wrap = el.parentElement
      gsap.set(el, { scale: 1.25 })
      gsap.fromTo(
        el,
        { yPercent: 8 },
        {
          yPercent: -8,
          ease: 'none',
          scrollTrigger: {
            trigger: wrap,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
          },
        },
      )
    })
  } else {
    reveal()
  }
})
